import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {InventoryPdgElementImportFileHdr} from '../../../../../models/aggregates/inventory-pdg';
import { ApiVisa } from '../shared';

@Injectable({providedIn: 'root'})
export class InventoryPdgElementImportFileService extends BaseApiTemplateService<InventoryPdgElementImportFileHdr> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX  + 'pdg-element/import-file-hdrs/' + + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX  + 'pdg-element/import-file-hdrs/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
  public upload(formData: FormData, visa: ApiVisa) {
        let url = visa.api_domain_url + this.endpoint_path;
        return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

}